import { useTranslation } from 'react-i18next';
import useModal from 'hooks/useModal';
import { CarModel } from 'models/StockModel';
import PhotoDialog from 'modules/transportation/dialogs/PhotoDialog';
import useCarPhotos from 'modules/cars/hooks/useCarPhotos';


const useTransportationModals = () => {
    const {t} = useTranslation('cars');
    const {showModal, hideModal} = useModal();
    const {addPhotos} = useCarPhotos();

    const openPhotosModal = (car: CarModel, id: number) => showModal(PhotoDialog,
        {car},
        {
            title: t('upload_photos'),
            maxWidth: 'sm',
            fullWidth: true,
        })
        .then(photos => addPhotos(car.id , [{
            name: `transport-${id}`,
            text: '',
            photos,
        }]))
        .then(hideModal);

    return {
        openPhotosModal,
    };
};

export default useTransportationModals;
